/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetClientDto } from './GetClientDto';
import {
    GetClientDtoFromJSON,
    GetClientDtoFromJSONTyped,
    GetClientDtoToJSON,
} from './GetClientDto';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';
import type { GetProjectDto } from './GetProjectDto';
import {
    GetProjectDtoFromJSON,
    GetProjectDtoFromJSONTyped,
    GetProjectDtoToJSON,
} from './GetProjectDto';
import type { GetPurchaseInvoiceDto } from './GetPurchaseInvoiceDto';
import {
    GetPurchaseInvoiceDtoFromJSON,
    GetPurchaseInvoiceDtoFromJSONTyped,
    GetPurchaseInvoiceDtoToJSON,
} from './GetPurchaseInvoiceDto';
import type { GetSalesInvoiceDto } from './GetSalesInvoiceDto';
import {
    GetSalesInvoiceDtoFromJSON,
    GetSalesInvoiceDtoFromJSONTyped,
    GetSalesInvoiceDtoToJSON,
} from './GetSalesInvoiceDto';
import type { GetTeamDto } from './GetTeamDto';
import {
    GetTeamDtoFromJSON,
    GetTeamDtoFromJSONTyped,
    GetTeamDtoToJSON,
} from './GetTeamDto';

/**
 * 
 * @export
 * @interface GetEodImportLogDtoPurchaseInvoice
 */
export interface GetEodImportLogDtoPurchaseInvoice {
    /**
     * 
     * @type {string}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    number: string;
    /**
     * 
     * @type {number}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    systemNumber: number;
    /**
     * 
     * @type {Date}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    sellDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    issueDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    paymentDate: Date;
    /**
     * 
     * @type {GetClientDto}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    client: GetClientDto;
    /**
     * 
     * @type {string}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    amountWithoutPosition: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    type: GetEodImportLogDtoPurchaseInvoiceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    status: GetEodImportLogDtoPurchaseInvoiceStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    currency: GetEodImportLogDtoPurchaseInvoiceCurrencyEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    exchangeRate: string;
    /**
     * 
     * @type {Array<GetProjectDto>}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    projects?: Array<GetProjectDto>;
    /**
     * 
     * @type {Array<GetTeamDto>}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    teams?: Array<GetTeamDto>;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    creator: GetEmployeeDto;
    /**
     * 
     * @type {Date}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    creationTs: Date;
    /**
     * 
     * @type {string}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    comment: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    tv: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    changeAmountsTs?: Date;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    changeAmountsOwner?: GetEmployeeDto;
    /**
     * 
     * @type {GetSalesInvoiceDto}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    salesInvoice?: GetSalesInvoiceDto;
    /**
     * 
     * @type {number}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    eodId?: number;
    /**
     * 
     * @type {GetPurchaseInvoiceDto}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    originalInvoice?: GetPurchaseInvoiceDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    paid: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    toSendPosting: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    toSendToEod: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    deletingReason?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    wasSent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetEodImportLogDtoPurchaseInvoice
     */
    automaticApproved?: boolean;
}


/**
 * @export
 */
export const GetEodImportLogDtoPurchaseInvoiceTypeEnum = {
    Foreign: 'Foreign',
    Domestic: 'Domestic'
} as const;
export type GetEodImportLogDtoPurchaseInvoiceTypeEnum = typeof GetEodImportLogDtoPurchaseInvoiceTypeEnum[keyof typeof GetEodImportLogDtoPurchaseInvoiceTypeEnum];

/**
 * @export
 */
export const GetEodImportLogDtoPurchaseInvoiceStatusEnum = {
    Open: 'Open',
    Approved: 'Approved',
    Sent: 'Sent'
} as const;
export type GetEodImportLogDtoPurchaseInvoiceStatusEnum = typeof GetEodImportLogDtoPurchaseInvoiceStatusEnum[keyof typeof GetEodImportLogDtoPurchaseInvoiceStatusEnum];

/**
 * @export
 */
export const GetEodImportLogDtoPurchaseInvoiceCurrencyEnum = {
    Pln: 'PLN',
    Usd: 'USD',
    Eur: 'EUR',
    Czk: 'CZK',
    Rub: 'RUB',
    Huf: 'HUF',
    Gbp: 'GBP',
    Bgn: 'BGN',
    Ron: 'RON',
    Hrk: 'HRK',
    Aud: 'AUD'
} as const;
export type GetEodImportLogDtoPurchaseInvoiceCurrencyEnum = typeof GetEodImportLogDtoPurchaseInvoiceCurrencyEnum[keyof typeof GetEodImportLogDtoPurchaseInvoiceCurrencyEnum];


/**
 * Check if a given object implements the GetEodImportLogDtoPurchaseInvoice interface.
 */
export function instanceOfGetEodImportLogDtoPurchaseInvoice(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "number" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "sellDate" in value;
    isInstance = isInstance && "issueDate" in value;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "client" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "amountWithoutPosition" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "companyId" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "exchangeRate" in value;
    isInstance = isInstance && "creator" in value;
    isInstance = isInstance && "creationTs" in value;
    isInstance = isInstance && "comment" in value;
    isInstance = isInstance && "tv" in value;
    isInstance = isInstance && "paid" in value;
    isInstance = isInstance && "toSendPosting" in value;
    isInstance = isInstance && "toSendToEod" in value;

    return isInstance;
}

export function GetEodImportLogDtoPurchaseInvoiceFromJSON(json: any): GetEodImportLogDtoPurchaseInvoice {
    return GetEodImportLogDtoPurchaseInvoiceFromJSONTyped(json, false);
}

export function GetEodImportLogDtoPurchaseInvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEodImportLogDtoPurchaseInvoice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'],
        'systemNumber': json['systemNumber'],
        'sellDate': (new Date(json['sellDate'])),
        'issueDate': (new Date(json['issueDate'])),
        'paymentDate': (new Date(json['paymentDate'])),
        'client': GetClientDtoFromJSON(json['client']),
        'amount': json['amount'],
        'amountWithoutPosition': json['amountWithoutPosition'],
        'active': json['active'],
        'companyId': json['companyId'],
        'type': json['type'],
        'status': json['status'],
        'currency': json['currency'],
        'exchangeRate': json['exchangeRate'],
        'projects': !exists(json, 'projects') ? undefined : ((json['projects'] as Array<any>).map(GetProjectDtoFromJSON)),
        'teams': !exists(json, 'teams') ? undefined : ((json['teams'] as Array<any>).map(GetTeamDtoFromJSON)),
        'creator': GetEmployeeDtoFromJSON(json['creator']),
        'creationTs': (new Date(json['creationTs'])),
        'comment': json['comment'],
        'tv': json['tv'],
        'changeAmountsTs': !exists(json, 'changeAmountsTs') ? undefined : (new Date(json['changeAmountsTs'])),
        'changeAmountsOwner': !exists(json, 'changeAmountsOwner') ? undefined : GetEmployeeDtoFromJSON(json['changeAmountsOwner']),
        'salesInvoice': !exists(json, 'salesInvoice') ? undefined : GetSalesInvoiceDtoFromJSON(json['salesInvoice']),
        'eodId': !exists(json, 'eodId') ? undefined : json['eodId'],
        'originalInvoice': !exists(json, 'originalInvoice') ? undefined : GetPurchaseInvoiceDtoFromJSON(json['originalInvoice']),
        'paid': json['paid'],
        'toSendPosting': json['toSendPosting'],
        'toSendToEod': json['toSendToEod'],
        'deletingReason': !exists(json, 'deletingReason') ? undefined : json['deletingReason'],
        'wasSent': !exists(json, 'wasSent') ? undefined : json['wasSent'],
        'automaticApproved': !exists(json, 'automaticApproved') ? undefined : json['automaticApproved'],
    };
}

export function GetEodImportLogDtoPurchaseInvoiceToJSON(value?: GetEodImportLogDtoPurchaseInvoice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'number': value.number,
        'systemNumber': value.systemNumber,
        'sellDate': (value.sellDate.toISOString()),
        'issueDate': (value.issueDate.toISOString()),
        'paymentDate': (value.paymentDate.toISOString()),
        'client': GetClientDtoToJSON(value.client),
        'amount': value.amount,
        'amountWithoutPosition': value.amountWithoutPosition,
        'active': value.active,
        'companyId': value.companyId,
        'type': value.type,
        'status': value.status,
        'currency': value.currency,
        'exchangeRate': value.exchangeRate,
        'projects': value.projects === undefined ? undefined : ((value.projects as Array<any>).map(GetProjectDtoToJSON)),
        'teams': value.teams === undefined ? undefined : ((value.teams as Array<any>).map(GetTeamDtoToJSON)),
        'creator': GetEmployeeDtoToJSON(value.creator),
        'creationTs': (value.creationTs.toISOString()),
        'comment': value.comment,
        'tv': value.tv,
        'changeAmountsTs': value.changeAmountsTs === undefined ? undefined : (value.changeAmountsTs.toISOString()),
        'changeAmountsOwner': GetEmployeeDtoToJSON(value.changeAmountsOwner),
        'salesInvoice': GetSalesInvoiceDtoToJSON(value.salesInvoice),
        'eodId': value.eodId,
        'originalInvoice': GetPurchaseInvoiceDtoToJSON(value.originalInvoice),
        'paid': value.paid,
        'toSendPosting': value.toSendPosting,
        'toSendToEod': value.toSendToEod,
        'deletingReason': value.deletingReason,
        'wasSent': value.wasSent,
        'automaticApproved': value.automaticApproved,
    };
}

